export const TruckIcon: React.FC<React.ComponentProps<"svg">> = ({
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 3C1.44772 3 1 3.44772 1 4V16C1 16.5523 1.44772 17 2 17H3.17071C3.06015 17.3128 3 17.6494 3 18C3 19.6569 4.34315 21 6 21C7.65685 21 9 19.6569 9 18C9 17.6494 8.93985 17.3128 8.82929 17H15.1707C15.0602 17.3128 15 17.6494 15 18C15 19.6569 16.3431 21 18 21C19.6569 21 21 19.6569 21 18C21 17.6494 20.9398 17.3128 20.8293 17H22C22.5523 17 23 16.5523 23 16V11C23 10.7613 22.9146 10.5305 22.7593 10.3492L20.1878 7.34921C19.9978 7.12756 19.7205 7 19.4286 7H17V4C17 3.44772 16.5523 3 16 3H2ZM21 15V11.3699L18.9686 9H17V15H21ZM18 17C17.4477 17 17 17.4477 17 18C17 18.5523 17.4477 19 18 19C18.5523 19 19 18.5523 19 18C19 17.4477 18.5523 17 18 17ZM5 18C5 17.4477 5.44772 17 6 17C6.55228 17 7 17.4477 7 18C7 18.5523 6.55228 19 6 19C5.44772 19 5 18.5523 5 18ZM15 15H3V5H15V15Z"
        fill="currentColor"
      />
    </svg>
  );
};
